exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tip-wrap {\n\twhite-space: normal;\n\tfont-weight: normal;\n\ttext-align: left;\n\tmargin-left: 3px;\n}\n.tip-break-cancel { /* чтобы иконка при дефиците места не съезжала */\n\twhite-space: nowrap;\n}\n.tip-break-cancel > * {\n\twhite-space: normal;\n}\n", ""]);
